import { NavLink } from "react-router-dom";
import { useAuth } from "../../auth/useAuth";

interface MenuEntry {
  label: string;
  to: string;
  adminOnly?: boolean;
}

const ENTRIES: MenuEntry[] = [
  { label: "Tableau de bord", to: "/admin" },
  { label: "Parcours", to: "/admin/parcours" },
  { label: "Lieux", to: "/admin/lieux" },
  { label: "Artistes", to: "/admin/artists" },
  { label: "Demandes de publication", to: "/admin/publication-requests", adminOnly: true },
  { label: "Membres", to: "/admin/members", adminOnly: true },
  { label: "Moissonnage", to: "/admin/harvest", adminOnly: true },
];

export default function Sidebar() {
  const { isAdmin } = useAuth();
  const visible = ENTRIES.filter((e) => !e.adminOnly || isAdmin);

  return (
    <aside className="bo-sidebar">
      <div className="bo-sidebar__brand">Mozaika · Admin</div>
      <nav className="bo-sidebar__nav">
        {visible.map((entry) => (
          <NavLink
            key={entry.to}
            to={entry.to}
            end={entry.to === "/admin"}
            className={({ isActive }) => `bo-sidebar__link${isActive ? " is-active" : ""}`}
          >
            {entry.label}
          </NavLink>
        ))}
      </nav>
      <NavLink to="/" className="bo-sidebar__return">
        ← Retour au site
      </NavLink>
    </aside>
  );
}
